import { render, staticRenderFns } from "./DetalheContrato.vue?vue&type=template&id=f3441b84"
import script from "./DetalheContrato.vue?vue&type=script&lang=js"
export * from "./DetalheContrato.vue?vue&type=script&lang=js"
import style0 from "./DetalheContrato.vue?vue&type=style&index=0&id=f3441b84&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports